// ======================================================================
// File Name       : page
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const SAVE_SEARCH_CONDITION = 'SAVE_SEARCH_CONDITION';
export const CLEAR_SEARCH_CONDITION = 'CLEAR_SEARCH_CONDITION';
export const RELOAD_COMPONENT = 'RELOAD_COMPONENT';
export const SAVE_SEARCH_CONDITION_SUB = 'SAVE_SEARCH_CONDITION_SUB';
export const CLEAR_SEARCH_CONDITION_SUB = 'CLEAR_SEARCH_CONDITION_SUB';
export const SAVE_SEARCH_CONDITION_HISTORY = 'SAVE_SEARCH_CONDITION_HISTORY';
export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
